import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { translateFn } from '../../../../utils/translator.helper';
import { FontSizes } from '../../../../types/common/types';
import { GzLandingPageCompanyType } from '../../../../landingPage/types';
import { getLandingPageReference } from '../../../../landingPage/utils';
import { getTranslatedProductsHubDescriptionText } from '../../../../productTrials/b2b/utils/utils';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { NavigationHelper } from '@nirvana/shared/navigation';

/**
 * @summary Type here the description of this component
 * @tag gz-product-trials-widget
 * Here https://custom-elements-manifest.open-wc.org/analyzer/getting-started/ you can find out how to document the code
 */
@customElement('gz-product-trials-widget')
export class ProductTrialsWebComponent extends LitElement {
  @property({ type: Number })
  companyType: GzLandingPageCompanyType;

  @property({ type: String, reflect: true })
  featureId: string;

  @property({ type: Boolean })
  goToFeatureButtonDisabled = false;

  static get styles() {
    return styles;
  }

  render() {
    return html`
      <div class="product-trials-banner">
        <div class="image-container">
          <img src="app/webcomponents/assets/images/landingPage/product_trials_hub_transp.svg" />
        </div>
        <div class="data-container">
          <gz-title id="product-trials-title" class="mb-2 header-title" fontSize="${FontSizes.TITLE}">
            ${unsafeHTML(this.getTitle())}
          </gz-title>
          <gz-text id="product-trials-description" class="fs-14"> ${this.getDescription()}</gz-text>
          <div class="btns-container mt-3">
            <gz-tooltip>
              <gz-button
                id="product-trials-action-button"
                class="feature-btn mr-2 mb-2"
                type="full"
                color="primary"
                theme="light"
                buttonHeight="medium"
                buttonFontSize="medium"
                @click="${() => this.featureBtnAction()}"
                ?disabled="${this.goToFeatureButtonDisabled}"
                buttonFontSize="medium"
              >
                ${translateFn('Go to Feature')}
              </gz-button>
            </gz-tooltip>
            <gz-button
              id="product-trials-support-button"
              class="suport-center"
              type="outline"
              color="secondary"
              theme="dark"
              buttonHeight="medium"
              buttonFontSize="medium"
              @click="${() => this.supportCenterBtnAction()}"
            >
              ${translateFn('Support Center')}
            </gz-button>
          </div>
        </div>
      </div>
    `;
  }

  private featureBtnAction(): void {
    try {
      analytics.trackPageInteraction({
        reference: `${getLandingPageReference(this.companyType)}`,
        asset: this.featureId,
      });
    } finally {
      switch (this.companyType) {
        case GzLandingPageCompanyType.CUSTOMER:
          this.dispatchEvent(
            new Event('go-to-feature-product-trials', {
              bubbles: true,
              composed: true,
            })
          );
          break;
        default:
          break;
      }
    }
  }

  private supportCenterBtnAction(): void {
    let link = '';
    switch (this.companyType) {
      case GzLandingPageCompanyType.CUSTOMER:
        link = 'https://www.bitdefender.com/business/support/en/77209-262787-product-trials-hub.html';
        break;
      default:
        break;
    }

    link = link + `?icid=button|b|${getLandingPageReference(this.companyType)}|go-to-support-center-for-product-trials`;
    window.open(link, '_blank');
  }

  private getTitle(): string {
    switch (this.companyType) {
      case GzLandingPageCompanyType.CUSTOMER:
        return translateFn('Products Hub');
      default:
        return '';
    }
  }
  private getDescription(): string {
    switch (this.companyType) {
      case GzLandingPageCompanyType.CUSTOMER:
        return getTranslatedProductsHubDescriptionText();
      default:
        return '';
    }
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'gz-product-trials-widget': ProductTrialsWebComponent;
  }
}
